var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a",
    {
      staticClass:
        "btn btn--outline btn--outline-dark w-100 text-shade-dark-hover",
      attrs: {
        href: _vm.url,
        disabled: !_vm.configuratorService.isConfigurationComplete(),
        target: "_blank",
      },
    },
    [
      _c(
        "svg",
        {
          staticClass: "svg-icon icon-print mr-2",
          attrs: {
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 14.88 13.39",
          },
        },
        [
          _c("path", {
            attrs: {
              d: "M2.81 9.75H.76A.71.71 0 010 9V2.9a.71.71 0 01.75-.74h13.39a.67.67 0 01.74.74V9a.67.67 0 01-.72.73h-2.08v3.07a.53.53 0 01-.57.59H3.4a.53.53 0 01-.57-.58V9.94a.55.55 0 01-.02-.19zm8.58 3V7.29H3.48v5.42zm1.83-8.3a.6.6 0 00-.6-.6.61.61 0 00-.61.61.61.61 0 001.21 0z",
              fill: "#3a3a39",
            },
          }),
          _vm._v(" "),
          _c("path", {
            attrs: {
              d: "M12 1.28H2.34V.5a.5.5 0 01.5-.5H12a.5.5 0 01.5.5v.78z",
              fill: "#3a3a39",
              "fill-rule": "evenodd",
            },
          }),
        ]
      ),
      _vm._v("\n    " + _vm._s(_vm._f("translate")("txtPrintOffer")) + "\n"),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }